import React from 'react';
import styles from './css/index.module.css';

const AiWardenRisksPanel = ({ onSubmit, submitting }) => {
    return (
        <>
            <p className={styles.aiWardenTip}>
                Identify risks, red flags, weak signals, inconsistencies, and uncertainty from the selected scope using retrieved evidence only.
            </p>
            <div className={styles.aiWardenAskActions}>
                <button type="button" className={styles.aiWardenPrimaryBtn} onClick={onSubmit} disabled={submitting}>
                    {submitting ? 'Thinking…' : 'Run Risks & Signals'}
                </button>
                <span className={styles.aiWardenTip}>Output uses only retrieved context from your selection.</span>
            </div>
        </>
    );
};

export default AiWardenRisksPanel;
